/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './refreshIdentity.defs'
export { main as default } from './refreshIdentity.defs'
